// extracted by mini-css-extract-plugin
module.exports = {"spinner":"VsMemberCheckbox_spinner__n9GPM"};